import type { ReactNode } from "react";
import { useBrandAnswer } from "@fox1ck-org/auth/saas/react";
import { SaasGate } from "@fox1ck-org/auth/ui";
import { BrandTile } from "@fox1ck-org/ui";

import { PRODUCT } from "@/lib/brand";

/**
 * The one way in: no page of ours. A live Keycloak session passes without a
 * click, anyone else sees the realm's page; «Входим», a failed return and the
 * session's end are the kit's screens. Everyone signed in works here: the
 * admin screens answer to the client role, on the API and in the rail.
 */
export function Gate({ children }: { children: ReactNode }) {
  const brand = useBrandAnswer();
  return (
    <SaasGate
      product={{ ...PRODUCT, mark: <BrandTile mark={brand.mark || null} /> }}
      locale="ru"
      labels={{ endorsedBy: () => "" }}
    >
      {children}
    </SaasGate>
  );
}
